import "./popup.css";

function Loader() {
  return (
    <>
      <div className="loading-wave">
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
      </div>
    </>
  );
}

export default Loader;
